import type { Star } from "@/types/content";

export const starGenders = ["男", "女"];

export const starNationalities = ["中国", "中国香港", "美国", "英国", "日本"];

export const starGenres = ["剧情", "喜剧", "动作", "科幻", "悬疑", "爱情"];

export const stars: Star[] = [
  {
    id: "star-01",
    name: "林知遥",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20an%20elegant%20East%20Asian%20young%20woman%20with%20long%20dark%20hair%2C%20soft%20even%20lighting%2C%20deep%20blue%20gradient%20background%20with%20subtle%20warm%20orange%20rim%20light%2C%20clean%20minimal%20editorial%20headshot%2C%20high%20detail&width=600&height=600&seq=star-01&orientation=squarish",
    gender: "女",
    nationality: "中国",
    birthDate: "1994-03-12",
    profession: "演员",
    filmIds: ["film-01", "film-07"],
    bio: [
      "林知遥，1994 年出生于江南小城，毕业于国内知名戏剧学院表演系。",
      "她以细腻而有层次的情绪表达著称，既能驾驭大规模的科幻题材，也能在爱情片里呈现克制的温柔。",
      "近年她开始尝试担任制片人，关注女性题材与新人导演的扶持。",
    ],
    topicIds: ["topic-01", "topic-05", "topic-08"],
    tags: ["实力派", "科幻女主", "文艺", "制片人"],
  },
  {
    id: "star-02",
    name: "沈亦舟",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20handsome%20East%20Asian%20young%20man%20with%20short%20black%20hair%2C%20calm%20confident%20expression%2C%20deep%20blue%20gradient%20background%20with%20subtle%20warm%20orange%20rim%20light%2C%20clean%20minimal%20editorial%20headshot%2C%20high%20detail&width=600&height=600&seq=star-02&orientation=squarish",
    gender: "男",
    nationality: "中国",
    birthDate: "1990-11-25",
    profession: "演员 / 导演",
    filmIds: ["film-01", "film-06", "film-12"],
    bio: [
      "沈亦舟，1990 年出生，出道十余年，是兼具票房号召力与口碑的男演员之一。",
      "他偏爱有挑战性的角色，从深空探险到冷峻警探，戏路跨度极大。",
      "近年来他尝试执导短片，被视为最有潜力的转型创作者。",
    ],
    topicIds: ["topic-01", "topic-04", "topic-07"],
    tags: ["票房担当", "多面手", "转型导演"],
  },
  {
    id: "star-03",
    name: "顾念之",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20gentle%20East%20Asian%20woman%20with%20tied%20up%20hair%20and%20a%20soft%20smile%2C%20soft%20even%20lighting%2C%20deep%20blue%20gradient%20background%20with%20subtle%20warm%20orange%20rim%20light%2C%20clean%20minimal%20editorial%20headshot%2C%20high%20detail&width=600&height=600&seq=star-03&orientation=squarish",
    gender: "女",
    nationality: "中国",
    birthDate: "1988-07-04",
    profession: "演员",
    filmIds: ["film-02", "film-08"],
    bio: [
      "顾念之，1988 年出生，以现实题材作品见长，是评论界公认的演技派。",
      "她习惯为角色提前数月体验生活，从刑警到乡村教师都亲身体验。",
      "低调的她很少参与综艺，把大部分时间留给了剧本与舞台。",
    ],
    topicIds: ["topic-02", "topic-06"],
    tags: ["演技派", "现实题材", "低调"],
  },
  {
    id: "star-04",
    name: "陆行川",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20serious%20East%20Asian%20man%20with%20a%20short%20beard%20and%20thoughtful%20eyes%2C%20dramatic%20soft%20lighting%2C%20deep%20blue%20gradient%20background%20with%20subtle%20warm%20orange%20rim%20light%2C%20clean%20minimal%20editorial%20headshot%2C%20high%20detail&width=600&height=600&seq=star-04&orientation=squarish",
    gender: "男",
    nationality: "中国香港",
    birthDate: "1982-01-18",
    profession: "演员",
    filmIds: ["film-02", "film-06"],
    bio: [
      "陆行川，1982 年出生于香港，早年在剧场打磨演技，后转战影视。",
      "他擅长塑造沉默寡言却内心汹涌的角色，是悬疑犯罪题材的常客。",
      "港片影迷称他「最会用一个眼神讲故事的人」。",
    ],
    topicIds: ["topic-02", "topic-04"],
    tags: ["港片", "悬疑专业户", "剧场出身"],
  },
  {
    id: "star-05",
    name: "苏晚棠",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20warm%20smiling%20East%20Asian%20woman%20with%20shoulder%20length%20curly%20hair%2C%20soft%20even%20lighting%2C%20deep%20blue%20gradient%20background%20with%20subtle%20warm%20orange%20rim%20light%2C%20clean%20minimal%20editorial%20headshot%2C%20high%20detail&width=600&height=600&seq=star-05&orientation=squarish",
    gender: "女",
    nationality: "中国",
    birthDate: "1996-09-30",
    profession: "演员",
    filmIds: ["film-03", "film-11"],
    bio: [
      "苏晚棠，1996 年出生，凭年代剧中的出色表现进入大众视野。",
      "她的表演自然放松，喜剧与正剧之间切换自如。",
      "私下里她热爱绘画，常在社交平台分享自己的手绘作品。",
    ],
    topicIds: ["topic-03", "topic-06"],
    tags: ["新生代", "喜剧感", "手绘爱好者"],
  },
  {
    id: "star-06",
    name: "江怀瑾",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20mature%20distinguished%20East%20Asian%20man%20with%20grey%20temples%20and%20calm%20expression%2C%20soft%20even%20lighting%2C%20deep%20blue%20gradient%20background%20with%20subtle%20warm%20orange%20rim%20light%2C%20clean%20minimal%20editorial%20headshot%2C%20high%20detail&width=600&height=600&seq=star-06&orientation=squarish",
    gender: "男",
    nationality: "中国",
    birthDate: "1972-05-20",
    profession: "演员",
    filmIds: ["film-01", "film-03", "film-07", "film-10"],
    bio: [
      "江怀瑾，1972 年出生，从艺三十余年，是公认的国宝级表演艺术家。",
      "他塑造的历史人物形象深入人心，被誉为「行走的教科书」。",
      "如今他依然坚持每年回归舞台，身体力行地影响着年轻一代。",
    ],
    topicIds: ["topic-03", "topic-07", "topic-08"],
    tags: ["老戏骨", "国宝级", "舞台常青"],
  },
  {
    id: "star-07",
    name: "温以宁",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20youthful%20cheerful%20East%20Asian%20woman%20with%20a%20ponytail%2C%20bright%20soft%20lighting%2C%20deep%20blue%20gradient%20background%20with%20subtle%20warm%20orange%20rim%20light%2C%20clean%20minimal%20editorial%20headshot%2C%20high%20detail&width=600&height=600&seq=star-07&orientation=squarish",
    gender: "女",
    nationality: "中国",
    birthDate: "2000-02-14",
    profession: "演员 / 配音",
    filmIds: ["film-05", "film-09"],
    bio: [
      "温以宁，2000 年出生，是新生代演员中的多栖代表。",
      "除了影视剧，她还为多部动画电影配音，声音辨识度极高。",
      "她被粉丝称为「元气担当」，擅长塑造明亮有生命力的角色。",
    ],
    topicIds: ["topic-05", "topic-06"],
    tags: ["新生代", "配音", "元气"],
  },
  {
    id: "star-08",
    name: "裴云舟",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20friendly%20East%20Asian%20man%20with%20round%20glasses%20and%20a%20playful%20smile%2C%20soft%20even%20lighting%2C%20deep%20blue%20gradient%20background%20with%20subtle%20warm%20orange%20rim%20light%2C%20clean%20minimal%20editorial%20headshot%2C%20high%20detail&width=600&height=600&seq=star-08&orientation=squarish",
    gender: "男",
    nationality: "中国",
    birthDate: "1986-12-08",
    profession: "演员 / 编剧",
    filmIds: ["film-04", "film-08", "film-11"],
    bio: [
      "裴云舟，1986 年出生，既是演员也是编剧，擅长都市喜剧与生活流故事。",
      "他的作品总能在嬉笑之间戳中普通人的软肋。",
      "「把平凡的日子写得有光」是他一直坚持的创作信条。",
    ],
    topicIds: ["topic-04", "topic-06"],
    tags: ["喜剧", "编剧", "生活流"],
  },
  {
    id: "star-09",
    name: "叶清欢",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20stylish%20East%20Asian%20woman%20with%20bob%20hair%20and%20confident%20gaze%2C%20soft%20even%20lighting%2C%20deep%20blue%20gradient%20background%20with%20subtle%20warm%20orange%20rim%20light%2C%20clean%20minimal%20editorial%20headshot%2C%20high%20detail&width=600&height=600&seq=star-09&orientation=squarish",
    gender: "女",
    nationality: "中国",
    birthDate: "1993-06-22",
    profession: "演员",
    filmIds: ["film-04", "film-12"],
    bio: [
      "叶清欢，1993 年出生，以都市剧中的独立女性形象获得广泛关注。",
      "她气质干练，常被邀请出演职场与悬疑类型作品。",
      "同时她也是时尚活动的常客，被媒体称为「行走的衣架子」。",
    ],
    topicIds: ["topic-05", "topic-07"],
    tags: ["都市剧", "时尚", "独立女性"],
  },
  {
    id: "star-10",
    name: "谢听澜",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20an%20athletic%20East%20Asian%20young%20man%20with%20short%20hair%20and%20energetic%20expression%2C%20soft%20even%20lighting%2C%20deep%20blue%20gradient%20background%20with%20subtle%20warm%20orange%20rim%20light%2C%20clean%20minimal%20editorial%20headshot%2C%20high%20detail&width=600&height=600&seq=star-10&orientation=squarish",
    gender: "男",
    nationality: "中国",
    birthDate: "1999-08-16",
    profession: "演员 / 运动员",
    filmIds: ["film-05", "film-10"],
    bio: [
      "谢听澜，1999 年出生，曾是专业短跑运动员，退役后转型演员。",
      "运动经历让他在动作与体育题材中格外真实可信。",
      "他希望在银幕上让更多人看到运动员背后的汗水与坚持。",
    ],
    topicIds: ["topic-04", "topic-08"],
    tags: ["运动员出身", "热血", "新人"],
  },
];